import { Action } from '@ngrx/store';
import { RideEvent } from 'src/app/models/ride-event';

export const RideEventAction = {
    createRideEvent: '[ride event] create ride event',
    deleteRideEvent: '[ride event] delete ride event',
    forceEventsRefresh: '[ride event] refresh on next pull',
    setActiveRideEvent: '[ride event] set active ride event',
    setPublicRideEvents: '[ride event] set public ride events',
    setRideEvents: '[ride event] set ride events',
    updateRideEvent: '[ride event] update ride event',
};

export class CreateRideEvent implements Action {
    type = RideEventAction.createRideEvent;
    constructor(public rideEvent: RideEvent) {}
}

export class DeleteRideEvent implements Action {
    type = RideEventAction.deleteRideEvent;
    constructor(public rideEventId: string) {}
}

export class ForceEventsRefresh implements Action {
    type = RideEventAction.forceEventsRefresh;
    constructor(public forceRefresh: boolean) {}
}

export class SetRideEvents implements Action {
    type = RideEventAction.setRideEvents;
    constructor(public rideEvents: RideEvent[]) {}
}

export class UpdateRideEvent implements Action {
    type = RideEventAction.updateRideEvent;
    constructor(public rideEvent: RideEvent) {}
}

export class SetPublicRideEvents implements Action {
    type = RideEventAction.setPublicRideEvents;
    constructor(public rideEvents: RideEvent[]) {}
}

export class SetActiveRideEvent implements Action {
    type = RideEventAction.setActiveRideEvent;
    constructor(public rideEvent: RideEvent | undefined) {}
}
